module.exports = __webpack_public_path__ + "static/media/Солеев А., Розет И., Мухтаров Я..38b46f57.pdf";